
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29 29"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#144B3C","stroke-width":"1.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M26.5 25.147c0 .747-.605 1.353-1.353 1.353H4.853A1.353 1.353 0 013.5 25.147V4.853c0-.747.605-1.353 1.353-1.353h20.294c.748 0 1.353.606 1.353 1.353v20.294z"}}),_c('path',{attrs:{"d":"M23.944 12.115h-5.633V6.48h-6.196v5.634H6.48v6.196h5.634v5.633h6.196V18.31h5.633v-6.196z"}})])])
          )
        }
      }
    